import { Component, ChangeDetectionStrategy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { CONTACT_US_PHONE_MAIN } from '../../shared/constants';

@Component({
    selector: 'app-header',
    imports: [
        RouterModule
    ],
    templateUrl: './header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './header.component.scss'
})
export class HeaderComponent {
  title = 'nordnative';
  CONTACT_US_PHONE_MAIN: string = CONTACT_US_PHONE_MAIN;

  // Angular routing doesn't trigger a page load, so Bootstrap's collapse never
  // auto-closes on nav-link click the way it would on a plain multi-page site.
  closeMobileMenu(): void {
    const navbarNav = document.getElementById('navbarNav')
    if (navbarNav?.classList.contains('show')) {
      const bsCollapse = (window as any).bootstrap?.Collapse?.getOrCreateInstance(navbarNav)
      bsCollapse?.hide()
    }
  }
}
